import { useEffect } from 'react';
import { Layout } from '@/components/layout/Layout';

const Lounge = () => {
  useEffect(() => {
    document.title = 'Diamond Club Lounge | Diamond Club Matchmaking';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'An exclusive members-only social experience where curated chemistry meets elevated, invitation-only gatherings.');
    }
  }, []);

  const vetPoints = [
    'Every member is personally met in person or via FaceTime',
    'We verify that all members accurately represent themselves and their photos',
    'Background checks are conducted on every participant',
    'Introductions are curated based on values, lifestyle and long-term relationship goals',
    'Attendance is by invitation only',
  ];

  return (
    <Layout>
      <section className="min-h-screen bg-black-deep grain-overlay">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 py-24 lg:py-32">
          {/* Page Title */}
          <h1 className="font-serif text-display-sm md:text-display text-cream text-center tracking-widest uppercase mb-12">
            The Diamond Club Lounge
          </h1>
          
          {/* 2x2 Image Grid */}
          <div className="grid grid-cols-2 gap-4 mb-16">
            {/* lounge-grid-1: Top Left */}
            <div 
              className="aspect-[4/3] bg-cover rounded-sm"
              style={{
                backgroundImage: `url('https://customer-assets.emergentagent.com/job_luxury-pairing/artifacts/o27h7hdm_Lounge%201.PNG')`,
                backgroundPosition: 'center 20%',
              }}
              data-placeholder="lounge-grid-1"
            ></div>
            
            {/* lounge-grid-2: Top Right */}
            <div 
              className="aspect-[4/3] bg-cover rounded-sm"
              style={{
                backgroundImage: `url('https://customer-assets.emergentagent.com/job_luxury-pairing/artifacts/0lguxfyy_Lounge%202.JPG')`,
                backgroundPosition: 'center 5%',
              }}
              data-placeholder="lounge-grid-2"
            ></div>
            
            {/* lounge-grid-3: Bottom Left */}
            <div 
              className="aspect-[4/3] bg-cover rounded-sm"
              style={{
                backgroundImage: `url('https://customer-assets.emergentagent.com/job_luxury-pairing/artifacts/0mi40csl_Lounge%203.JPG')`,
                backgroundPosition: 'center 20%',
              }}
              data-placeholder="lounge-grid-3"
            ></div>
            
            {/* lounge-grid-4: Bottom Right */}
            <div 
              className="aspect-[4/3] bg-cover rounded-sm"
              style={{
                backgroundImage: `url('https://customer-assets.emergentagent.com/job_luxury-pairing/artifacts/l9nncobc_Lounge%204.JPG')`,
                backgroundPosition: 'center 15%',
              }}
              data-placeholder="lounge-grid-4"
            ></div>
          </div>
          
          {/* Main Content */}
          <div className="max-w-3xl mx-auto">
            {/* Headline */}
            <h2 className="font-serif text-2xl md:text-3xl text-cream text-center mb-8 leading-relaxed">
              Where Curated Chemistry Meets Elevated Social Experiences
            </h2>
            
            {/* Description paragraphs */}
            <div className="space-y-6 mb-12">
              <p className="font-sans text-cream-muted text-base leading-relaxed">
                The Diamond Club Lounge is an exclusive members-only experience designed for
                individuals who value luxury, discretion, and meaningful connection.
              </p>
              
              <p className="font-sans text-cream-muted text-base leading-relaxed">
                These intimate gatherings bring together a carefully selected group of high-caliber
                men and women in refined settings where introductions unfold naturally —
                without pressure, pretense, or performance.
              </p>
            </div>
            
            {/* Three emphasis statements */}
            <div className="space-y-3 mb-16 py-8 border-y border-gold/20">
              <p className="font-sans text-cream text-base">This is not speed dating.</p>
              <p className="font-sans text-cream text-base">This is not a mixer.</p>
              <p className="font-sans text-cream text-base">This is modern, human-led matchmaking at its highest level.</p>
            </div>
            
            {/* Additional photo above Vetted section */}
            <div 
              className="aspect-[16/9] bg-cover rounded-sm mb-12"
              style={{
                backgroundImage: `url('https://customer-assets.emergentagent.com/job_luxury-pairing/artifacts/ub0zglh6_89e44fda-0a37-4844-819e-bc4b56bc7c44.png')`,
                backgroundPosition: 'center 30%',
              }}
              data-placeholder="lounge-extra"
            ></div>
            
            {/* Vetted Section */}
            <div className="text-center mb-8">
              <h3 className="font-serif text-2xl md:text-3xl text-cream mb-6">
                Every Guest Is Personally Vetted
              </h3>
              <p className="font-sans text-cream-muted text-base mb-8">
                At the Diamond Club Lounge, trust and integrity are foundational
              </p>
            </div>
            
            {/* Bullet points */}
            <ul className="space-y-4">
              {vetPoints.map((point, index) => (
                <li key={index} className="flex items-start gap-3">
                  <span className="text-gold text-lg mt-0.5">•</span>
                  <span className="font-sans text-cream-muted text-base">{point}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Lounge;
